import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 2.72rem;
  padding: .3rem ;
  justify-content: end;
`;
export const BtnOpenSelection = styled.span`
  border: none;
  outline: none;
  display: flex;
  height: 100%;
  display: flex;
  gap: .5rem;
  padding: 0 .5rem;
  justify-content: center;
  align-items: center;
  color: #999999;
  cursor: pointer;
  background: #ffffff;
  border-radius: 6px;
  &:hover {
    color: rgb(73, 80, 87);
  }
`;
export const Controls = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 .5rem;
  border-radius: 6px;
  > div {
    display: flex;
    gap: .5rem;
    .icl-{
      cursor: pointer;
    }
    > div {
      display: flex;
      align-items: center;
      gap: .5rem;
    }
    .icon--{
      transform: rotate(90deg);
      cursor: pointer;
    }
    > .dot-Act{
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

`;
export const Options = styled.div`
  position: absolute;
  width: 15rem;
  top: 2.5rem;
  right: 5px;
  z-index: 9999;
  > ul {
    display: flex;
    padding: .5rem;
    width: 100%;
    /* height: 5.2rem; */
    gap: .2rem;
    flex-direction: column;
    border-radius: 6px;
    background-color: rgb(246, 248, 252);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 8px 3px, rgba(0, 0, 0, 0.3) 0px 1px 3px;
    user-select: none;
    transition: height 0.1s ease-in-out;
    overflow: hidden;
    > li {
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 0 .5rem;
      min-width: 155px;
      height: 2rem;
      width: 100%;
      text-align: left;
      background: yellow;
      list-style: none;
      &:first-child{
        border-radius: 6px 6px 0 0;
      }
      &:last-child{
        border-radius: 0 0 6px 6px;
      }
      font-weight: 500;
      font-size: 0.775rem;
      line-height: 20px;
      letter-spacing: normal;
      color: rgb(73, 80, 87);
      cursor: pointer;
      background-color: rgb(255, 255, 255);
      &:hover {
        background-color: rgba(60, 64, 67, 0.08);
      }
    }
  }
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
export const LoadingProgress = styled.div`
    position: fixed;
    display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: default;
    animation: ModalShow .1s ease-out;
    user-select: none;
    background-color: #00000040;
    > div {
        width: 300px;
        height: 300px;
        display: flex;
        border-radius: 6px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        gap: 2rem;
        > div:nth-child(2){
          max-width: 200px;
        }
        .loader {
            width: 50px;
            aspect-ratio: 1;
            display: grid;
            border: 4px solid #0000;
            border-radius: 50%;
            border-right-color: #25b09b;
            animation: l15 1s infinite linear;
        }
        .loader::before,
        .loader::after {    
            content: "";
            grid-area: 1/1;
            margin: 2px;
            border: inherit;
            border-radius: 50%;
            animation: l15 2s infinite;
        }
        .loader::after {
            margin: 8px;
            animation-duration: 3s;
        }
        @keyframes l15{ 
            100%{transform: rotate(1turn)}
        }
    }

    @keyframes ModalShow{
        0% {
            opacity: 0;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    };
`;

export const WrapperOptions = styled.div`
  position: relative;
`;